import React, { Component } from "react";
import "../../Pages/Schedular.css";
import { post, del, get } from "../../custom_libraries/serverRequests";
import urls from "../../custom_libraries/urls";
import globalVariables from "../../custom_libraries/globalVariables";
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Tooltip from "@mui/material/Tooltip";
// import withNavigate from "../../Global_files/WithNavigate";
import BACK from '../../assets/icons8-back-arrow.gif'; 

const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
const timeSlots = Array.from({ length: 25 }, (_, i) =>
  `${i === 0 ? 12 : i > 12 ? i - 12 : i}:00 ${i < 12 ? "AM" : "PM"}`
);

// const timeSlots = Array.from({ length: 25 }, (_, i) => {
//   const hour = i === 0 ? 12 : i > 12 ? i - 12 : i;
//   const period = i < 12 ? "AM" : "PM";
//   return `${hour}:00 ${period}`;
// });

class Scheduler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBlocks: [],
      isDragging: false,
      success: false,
      error: false,
      warning: false,
      error_fetching:false,
      warning_fetching:false,
      success_clear: false,
      isEditing: false,
      frequency: "custom",
      originalSelectedBlocks: [], 
      deviceId:null,
    };
  }

  componentDidMount() {
    this.setState({ deviceId: localStorage.getItem(globalVariables.DEVICE_ID) });
    this.fetchScheduleData();
    
  }

  toggleEditMode = () => {
    this.setState((prevState) => {
      const newState = { isEditing: !prevState.isEditing };
      if (!prevState.isEditing) {
        // Store the original blocks when entering edit mode
        newState.originalSelectedBlocks = [...prevState.selectedBlocks];
      }
      return newState;
    });
  };

  cancelEdit = () => {
    // Revert to the original state before any changes
    this.setState((prevState) => ({
      selectedBlocks: [...prevState.originalSelectedBlocks],
      isEditing: false,
    }));
  };

  handleCellClick = (day, time) => {
    const block = { day, time };

    this.setState((prevState) => {
      const isSelected = prevState.selectedBlocks.some((b) => b.day === day && b.time === time);

      return {
        selectedBlocks: isSelected
          ? prevState.selectedBlocks.filter((b) => !(b.day === day && b.time === time)) // Remove if already selected
          : [...prevState.selectedBlocks, block], // Add new block
      };
    });
  };

  handleMouseDown = (day, time) => {
    this.setState({ isDragging: true });
    this.handleCellClick(day, time);
  };

  handleMouseEnter = (day, time) => {
    if (this.state.isDragging) {
      this.handleCellClick(day, time);
    }
  };

  handleMouseUp = () => {
    this.setState({ isDragging: false });
  };

  clearAllSchedules = async () => {
    const deviceId = localStorage.getItem(globalVariables.DEVICE_ID);
    
    if (!deviceId) {
      this.setState({ warning: true });
      console.error("Camera ID is missing.");
      return;
    }

    try {
      const response = await post(urls.CLEAR_SCHEDULE_DATA(deviceId));
      const expectedMessage = `All schedules for device ${deviceId} have been cleared.`;

      if (response.message && response.message === expectedMessage) {
        this.setState({ selectedBlocks: [], success_clear: true });
        console.log("All schedules cleared successfully.");
        setTimeout(() => {
        this.setState({isEditing:false, success_clear:false});
        this.fetchScheduleData()
      //     window.location.reload();
      }, 4000);
        
      } else {
        console.error("Failed to clear schedules:", response);
        this.setState({ error: true });
      }
    } catch (error) {
      console.error("Error clearing schedules:", error);
      this.setState({ error: true });
    }
  };


// Function to convert 12-hour time to 24-hour format
convertTo24HourFormat = (timeStr) => {
  const [time, modifier] = timeStr.split(" "); // Split time and AM/PM
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours !== 12) {
      hours += 12;
  } else if (modifier === "AM" && hours === 12) {
      hours = 0;
  }

  return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
};

convertTo12HourFormat = (timeStr) => {
  let [hours, minutes] = timeStr.split(":").map(Number);
  const period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${hours}:${minutes.toString().padStart(2, "0")} ${period}`;
};

  
          
  sendDeviceSchedule = async () => {
    const { selectedBlocks, frequency } = this.state;
    const deviceId = localStorage.getItem(globalVariables.DEVICE_ID);
  
    if (!deviceId) {
      this.setState({ warning: true });
      console.error("DeviceID is missing.");
      setTimeout(() => {
        this.setState({warning:false});
      }, 4500);
      return;
    }
  
    if (selectedBlocks.length === 0) {
      this.setState({ warning: true });
      console.error("No time blocks selected.");
      setTimeout(() => {
        this.setState({warning:false});
      }, 4500);
      return;
    }
  
    const payload = {
      device: deviceId,
      frequency,
      schedule: selectedBlocks.map((block) => ({
        device: deviceId,
        frequency,
        day: block.day,
        // time: block.time,
        time: this.convertTo24HourFormat(block.time), // Convert time to HH:mm
        id: block.id || null, // Include ID for updating existing schedules
      })),
    };
    const url = urls.UPDATE_SCHEDULE_DATA;
    console.log("URL for PUT request:", url);
    console.log("Payload for PUT request:", payload);
    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      // console.log("--------auth tocken---------", access_tocken);
      console.log("Payload:", payload);
      const response = await fetch(urls.UPDATE_SCHEDULE_DATA, {
        method: "POST", // Use PUT instead of POST
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${access_tocken}`
        },
        body: JSON.stringify(payload),
      });
  
      if (response.ok) {
        console.log("Schedules updated successfully.");
        this.setState({ success: true });
      } else {
        const errorData = await response.json();
        console.error("Error updating schedules:", errorData);
        this.setState({ error: true });
      }
      setTimeout(() => {
        // window.location.reload();
        this.setState({isEditing:false, success: false});
        this.fetchScheduleData()
    }, 2500);
    } catch (error) {
      console.error("Network or API error:", error);
      this.setState({ error: true });
    }
  };
  

  fetchScheduleData = async () => {
    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`
      }
      const deviceID = localStorage.getItem(globalVariables.DEVICE_ID);
      if (!deviceID) {
        console.error("Device ID is missing.");
        // this.setState({ error_fetching: true });
        return;
      }
  
      // const response = await fetch(urls.GET_SCHEDULE_DATA(deviceID), headers);
      const response = await fetch(urls.GET_SCHEDULE_DATA(deviceID), {
                  headers: headers,
              });
      if (response.ok) {
        const data = await response.json();
        console.log("Response: fetchScheduleData", data);
  
        if (Array.isArray(data)) {
          const selectedBlocks = data.map((item) => ({
            day: item.day,
            time: this.convertTo12HourFormat(item.time), // Convert time for matching
            id: item.schedule_id, // Include schedule ID for potential deletion
          }));
  
          this.setState({ selectedBlocks });
          console.log("Selected Blocks: fetchScheduleData", this.state.selectedBlocks);
        } else {
          console.warn("No schedule data available. Please add schedule.");
          this.setState({ warning_fetching: true });
        }
      } else {
        console.error("Failed to fetch schedule data:", response.status);
        this.setState({ error_fetching: true });
      }
    } catch (error) {
      console.error("Error fetching schedule data:", error);
      this.setState({ error_fetching: true });
    }
  };

  render() {
    const { selectedBlocks, success, error, warning, isEditing, warning_fetching, error_fetching, success_clear} = this.state;

    return (
      <div className="scheduler-container-schedule">
        {warning && <Alert severity="warning">Please select the required fields.</Alert>}
        {error && <Alert severity="error">Server Error! Could not process the request.</Alert>}
        {success && (
          <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
            Schedule information saved successfully.
          </Alert>
        )}
       {error_fetching && <Alert severity="error">Server Error! Could not get the scheduled time data.</Alert>}
       {warning_fetching && <Alert severity="warning">No scheduled time data available. Please add schedule.</Alert>}
       {success_clear && (
          <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
            Scheduled time data deleted successfully.
          </Alert>
        )}
        {/* <div style={{display:'flex', flexDirection:'row'}}>
        
        </div> */}
        <div className="grid-header-schedule">
        <div className="am-row">
          AM
        </div>
        <div className="pm-row">
          PM
        </div>
    <div className="empty-cell-schedule"></div>
    {timeSlots.map((time, index) => (
        <div key={`${time}-${index}`} className="header-cell-schedule">
            {time.split(" ")[0]} {/* Only show the hour:minute */}
        </div>
    ))}
</div>

        <div className="grid-body-schedule" onMouseLeave={() => this.setState({ isDragging: false })}>
          {days.map((day) => (
            <div key={day} className="row-schedule">
              <div className="day-cell-schedule">{day}</div>
              {timeSlots.map((time, index) => (
                <Tooltip key={`${time}-${index}`} title={`Time: ${time}`} placement="top" 
                slotProps={{
                  popper: {
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, -13], // Adjusts distance from cursor (Y = -5 moves closer)
                        },
                      },
                    ],
                  },
                }}
                >
                  <div
                    className={`cell-schedule ${selectedBlocks.some((b) => b.day === day && b.time === time)
                        ? "selected-schedule"
                        : ""
                      }`}
                    onMouseDown={() => isEditing && this.handleMouseDown(day, time)}
                    onMouseEnter={() => isEditing && this.handleMouseEnter(day, time)}
                    onMouseUp={this.handleMouseUp}
                  ></div>
                </Tooltip>
              ))}
            </div>
          ))}
        </div>

        <div className="buttons-schedule">
          {!isEditing ? (
            <button onClick={this.toggleEditMode} id="rowsPerPageButton">
              Edit
            </button>
          ) : (
            <>
              <button onClick={this.sendDeviceSchedule} className="save-button-schedule">
                Save
              </button>
              <button onClick={this.clearAllSchedules} className="clear-button-schedule">
                Clear All
              </button>
              <button onClick={this.cancelEdit} className="cancel-button-schedule">
                Cancel
              </button>
            </>
          )}
        </div>
      </div>
    );
  }
}

export default Scheduler;